import { Box } from "@tm/components"
import { WidgetSizes } from "@tm/controls"
import { concat } from "@tm/utils"
import { ReactNode } from "react"

type Props = {
    height?: number
    className?: string
    size?: WidgetSizes
    children: ReactNode
}

/** @description This component will be deprecated in the feature it is just a workarount until there is a new design of dashboards and startpages */
export function LegacyContainer(props: Props) {
    const { height, className, size, children } = props

    function getSizeClassnames(widgetSize: WidgetSizes): string {
        const testedSize = /(\d+)x(\d+)/.test(widgetSize) ? widgetSize : "4x2"
        const dimension = /(?<width>\d+)x(?<height>\d+)/.exec(testedSize)?.groups

        if (dimension) {
            return `widget--w${dimension.width} widget--h${dimension.height}`
        }

        return "widget--w4 widget--h2"
    }

    const widgetSizeClassNames = getSizeClassnames(size ?? "4x2")

    return (
        <Box className={`${concat(" ", widgetSizeClassNames, className)}`} {...(height !== undefined && { height: `${height}em` })}>
            {children}
        </Box>
    )
}
